import _objectWithoutProperties from "/Users/elliotwaterhouse/Desktop/GitHub/partners_aps/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "/Users/elliotwaterhouse/Desktop/GitHub/partners_aps/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/Users/elliotwaterhouse/Desktop/GitHub/partners_aps/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/Users/elliotwaterhouse/Desktop/GitHub/partners_aps/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "/Users/elliotwaterhouse/Desktop/GitHub/partners_aps/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function getSide(placement) {
  return placement.split('-')[0];
}

function getAlignment(placement) {
  return placement.split('-')[1];
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].includes(getSide(placement)) ? 'x' : 'y';
}

function getLengthFromAxis(axis) {
  return axis === 'y' ? 'height' : 'width';
}

function computeCoordsFromPlacement(_ref, placement, rtl) {
  var reference = _ref.reference,
      floating = _ref.floating;
  var commonX = reference.x + reference.width / 2 - floating.width / 2;
  var commonY = reference.y + reference.height / 2 - floating.height / 2;
  var mainAxis = getMainAxisFromPlacement(placement);
  var length = getLengthFromAxis(mainAxis);
  var commonAlign = reference[length] / 2 - floating[length] / 2;
  var side = getSide(placement);
  var isVertical = mainAxis === 'x';
  var coords;

  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;

    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;

    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }

  switch (getAlignment(placement)) {
    case 'start':
      coords[mainAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;

    case 'end':
      coords[mainAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }

  return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */


var computePosition = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(reference, floating, config) {
    var _config$placement, placement, _config$strategy, strategy, _config$middleware, middleware, platform, rtl, rects, _computeCoordsFromPla, x, y, statefulPlacement, middlewareData, resetCount, i, _middleware$i, name, fn, _yield$fn, nextX, nextY, data, reset, _computeCoordsFromPla2;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _config$placement = config.placement, placement = _config$placement === void 0 ? 'bottom' : _config$placement, _config$strategy = config.strategy, strategy = _config$strategy === void 0 ? 'absolute' : _config$strategy, _config$middleware = config.middleware, middleware = _config$middleware === void 0 ? [] : _config$middleware, platform = config.platform;
            _context.next = 3;
            return platform.isRTL == null ? void 0 : platform.isRTL(floating);

          case 3:
            rtl = _context.sent;

            if (!(process.env.NODE_ENV !== "production")) {
              _context.next = 8;
              break;
            }

            if (platform == null) {
              console.error(['Floating UI: `platform` property was not passed to config. If you', 'want to use Floating UI on the web, install @floating-ui/dom', 'instead of the /core package. Otherwise, you can create your own', '`platform`: https://floating-ui.com/docs/platform'].join(' '));
            }

            if (!(middleware.filter(function (_ref) {
              var name = _ref.name;
              return name === 'autoPlacement' || name === 'flip';
            }).length > 1)) {
              _context.next = 8;
              break;
            }

            throw new Error(['Floating UI: duplicate `flip` and/or `autoPlacement`', 'middleware detected. This will lead to an infinite loop. Ensure only', 'one of either has been passed to the `middleware` array.'].join(' '));

          case 8:
            _context.next = 10;
            return platform.getElementRects({
              reference: reference,
              floating: floating,
              strategy: strategy
            });

          case 10:
            rects = _context.sent;
            _computeCoordsFromPla = computeCoordsFromPlacement(rects, placement, rtl), x = _computeCoordsFromPla.x, y = _computeCoordsFromPla.y;
            statefulPlacement = placement;
            middlewareData = {};
            resetCount = 0;
            i = 0;

          case 16:
            if (!(i < middleware.length)) {
              _context.next = 50;
              break;
            }

            _middleware$i = middleware[i], name = _middleware$i.name, fn = _middleware$i.fn;
            _context.next = 20;
            return fn({
              x: x,
              y: y,
              initialPlacement: placement,
              placement: statefulPlacement,
              strategy: strategy,
              middlewareData: middlewareData,
              rects: rects,
              platform: platform,
              elements: {
                reference: reference,
                floating: floating
              }
            });

          case 20:
            _yield$fn = _context.sent;
            nextX = _yield$fn.x;
            nextY = _yield$fn.y;
            data = _yield$fn.data;
            reset = _yield$fn.reset;
            x = nextX != null ? nextX : x;
            y = nextY != null ? nextY : y;
            middlewareData = _objectSpread({}, middlewareData, _defineProperty({}, name, _objectSpread({}, middlewareData[name], data)));

            if (process.env.NODE_ENV !== "production") {
              if (resetCount > 50) {
                console.warn(['Floating UI: The middleware lifecycle appears to be running in an', 'infinite loop. This is usually caused by a `reset` continually', 'being returned without a break condition.'].join(' '));
              }
            }

            if (!(reset && resetCount <= 50)) {
              _context.next = 47;
              break;
            }

            resetCount++;

            if (!(typeof reset === 'object')) {
              _context.next = 45;
              break;
            }

            if (reset.placement) {
              statefulPlacement = reset.placement;
            }

            if (!reset.rects) {
              _context.next = 42;
              break;
            }

            if (!(reset.rects === true)) {
              _context.next = 40;
              break;
            }

            _context.next = 37;
            return platform.getElementRects({
              reference: reference,
              floating: floating,
              strategy: strategy
            });

          case 37:
            _context.t0 = _context.sent;
            _context.next = 41;
            break;

          case 40:
            _context.t0 = reset.rects;

          case 41:
            rects = _context.t0;

          case 42:
            _computeCoordsFromPla2 = computeCoordsFromPlacement(rects, statefulPlacement, rtl);
            x = _computeCoordsFromPla2.x;
            y = _computeCoordsFromPla2.y;

          case 45:
            i = -1;
            return _context.abrupt("continue", 47);

          case 47:
            i++;
            _context.next = 16;
            break;

          case 50:
            return _context.abrupt("return", {
              x: x,
              y: y,
              placement: statefulPlacement,
              strategy: strategy,
              middlewareData: middlewareData
            });

          case 51:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function computePosition(_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

function expandPaddingObject(padding) {
  return _objectSpread({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, padding);
}

function getSideObjectFromPadding(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}

function rectToClientRect(rect) {
  return _objectSpread({}, rect, {
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */


function detectOverflow(_x4, _x5) {
  return _detectOverflow.apply(this, arguments);
}

function _detectOverflow() {
  _detectOverflow = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(middlewareArguments, options) {
    var _await$platform$isEle, x, y, platform, rects, elements, strategy, _options7, _options7$boundary, boundary, _options7$rootBoundar, rootBoundary, _options7$elementCont, elementContext, _options7$altBoundary, altBoundary, _options7$padding, padding, paddingObject, altContext, element, clippingClientRect, elementClientRect;

    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            if (options === void 0) {
              options = {};
            }

            x = middlewareArguments.x, y = middlewareArguments.y, platform = middlewareArguments.platform, rects = middlewareArguments.rects, elements = middlewareArguments.elements, strategy = middlewareArguments.strategy;
            _options7 = options, _options7$boundary = _options7.boundary, boundary = _options7$boundary === void 0 ? 'clippingAncestors' : _options7$boundary, _options7$rootBoundar = _options7.rootBoundary, rootBoundary = _options7$rootBoundar === void 0 ? 'viewport' : _options7$rootBoundar, _options7$elementCont = _options7.elementContext, elementContext = _options7$elementCont === void 0 ? 'floating' : _options7$elementCont, _options7$altBoundary = _options7.altBoundary, altBoundary = _options7$altBoundary === void 0 ? false : _options7$altBoundary, _options7$padding = _options7.padding, padding = _options7$padding === void 0 ? 0 : _options7$padding;
            paddingObject = getSideObjectFromPadding(padding);
            altContext = elementContext === 'floating' ? 'reference' : 'floating';
            element = elements[altBoundary ? altContext : elementContext];
            _context10.t0 = rectToClientRect;
            _context10.t1 = platform;
            _context10.next = 10;
            return platform.isElement == null ? void 0 : platform.isElement(element);

          case 10:
            _context10.t2 = _await$platform$isEle = _context10.sent;

            if (!(_context10.t2 != null)) {
              _context10.next = 15;
              break;
            }

            _context10.t3 = _await$platform$isEle;
            _context10.next = 16;
            break;

          case 15:
            _context10.t3 = true;

          case 16:
            if (!_context10.t3) {
              _context10.next = 20;
              break;
            }

            _context10.t4 = element;
            _context10.next = 26;
            break;

          case 20:
            _context10.t5 = element.contextElement;

            if (_context10.t5) {
              _context10.next = 25;
              break;
            }

            _context10.next = 24;
            return platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating);

          case 24:
            _context10.t5 = _context10.sent;

          case 25:
            _context10.t4 = _context10.t5;

          case 26:
            _context10.t6 = _context10.t4;
            _context10.t7 = boundary;
            _context10.t8 = rootBoundary;
            _context10.t9 = strategy;
            _context10.t10 = {
              element: _context10.t6,
              boundary: _context10.t7,
              rootBoundary: _context10.t8,
              strategy: _context10.t9
            };
            _context10.next = 33;
            return _context10.t1.getClippingRect.call(_context10.t1, _context10.t10);

          case 33:
            _context10.t11 = _context10.sent;
            clippingClientRect = (0, _context10.t0)(_context10.t11);
            _context10.t12 = rectToClientRect;

            if (!platform.convertOffsetParentRelativeRectToViewportRelativeRect) {
              _context10.next = 49;
              break;
            }

            _context10.t14 = platform;
            _context10.t15 = elementContext === 'floating' ? _objectSpread({}, rects.floating, {
              x: x,
              y: y
            }) : rects.reference;
            _context10.next = 41;
            return platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating);

          case 41:
            _context10.t16 = _context10.sent;
            _context10.t17 = strategy;
            _context10.t18 = {
              rect: _context10.t15,
              offsetParent: _context10.t16,
              strategy: _context10.t17
            };
            _context10.next = 46;
            return _context10.t14.convertOffsetParentRelativeRectToViewportRelativeRect.call(_context10.t14, _context10.t18);

          case 46:
            _context10.t13 = _context10.sent;
            _context10.next = 50;
            break;

          case 49:
            _context10.t13 = rects[elementContext];

          case 50:
            _context10.t19 = _context10.t13;
            elementClientRect = (0, _context10.t12)(_context10.t19);
            return _context10.abrupt("return", {
              top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
              bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
              left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
              right: elementClientRect.right - clippingClientRect.right + paddingObject.right
            });

          case 53:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _detectOverflow.apply(this, arguments);
}

var min = Math.min;
var max = Math.max;

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
/**
 * Positions an inner element of the floating element such that it is centered
 * to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */


var arrow = function arrow(options) {
  return {
    name: 'arrow',
    options: options,
    fn: function () {
      var _fn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(middlewareArguments) {
        var _data, _ref4;

        var _ref3, element, _ref3$padding, padding, x, y, placement, rects, platform, paddingObject, coords, axis, alignment, length, arrowDimensions, minProp, maxProp, endDiff, startDiff, arrowOffsetParent, clientSize, centerToReference, min, max, center, offset, alignmentPadding, shouldAddOffset, alignmentOffset;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Since `element` is required, we don't Partial<> the type
                _ref3 = options != null ? options : {}, element = _ref3.element, _ref3$padding = _ref3.padding, padding = _ref3$padding === void 0 ? 0 : _ref3$padding;
                x = middlewareArguments.x, y = middlewareArguments.y, placement = middlewareArguments.placement, rects = middlewareArguments.rects, platform = middlewareArguments.platform;

                if (!(element == null)) {
                  _context2.next = 5;
                  break;
                }

                if (process.env.NODE_ENV !== "production") {
                  console.warn('Floating UI: No `element` was passed to the `arrow` middleware.');
                }

                return _context2.abrupt("return", {});

              case 5:
                paddingObject = getSideObjectFromPadding(padding);
                coords = {
                  x: x,
                  y: y
                };
                axis = getMainAxisFromPlacement(placement);
                alignment = getAlignment(placement);
                length = getLengthFromAxis(axis);
                _context2.next = 12;
                return platform.getDimensions(element);

              case 12:
                arrowDimensions = _context2.sent;
                minProp = axis === 'y' ? 'top' : 'left';
                maxProp = axis === 'y' ? 'bottom' : 'right';
                endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                startDiff = coords[axis] - rects.reference[axis];
                _context2.next = 19;
                return platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element);

              case 19:
                arrowOffsetParent = _context2.sent;
                clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;

                if (clientSize === 0) {
                  clientSize = rects.floating[length];
                }

                centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the floating element if the center
                // point is outside the floating element's bounds

                min = paddingObject[minProp];
                max = clientSize - arrowDimensions[length] - paddingObject[maxProp];
                center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                offset = within(min, center, max); // Make sure that arrow points at the reference

                alignmentPadding = alignment === 'start' ? paddingObject[minProp] : paddingObject[maxProp];
                shouldAddOffset = alignmentPadding > 0 && center !== offset && rects.reference[length] <= rects.floating[length];
                alignmentOffset = shouldAddOffset ? center < min ? min - center : max - center : 0;
                return _context2.abrupt("return", (_ref4 = {}, _defineProperty(_ref4, axis, coords[axis] - alignmentOffset), _defineProperty(_ref4, "data", (_data = {}, _defineProperty(_data, axis, offset), _defineProperty(_data, "centerOffset", center - offset), _data)), _ref4));

              case 31:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function fn(_x6) {
        return _fn.apply(this, arguments);
      }

      return fn;
    }()
  };
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};

function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }

  var alignment = getAlignment(placement);
  var mainAxis = getMainAxisFromPlacement(placement);
  var length = getLengthFromAxis(mainAxis);
  var mainAlignmentSide = mainAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';

  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }

  return {
    main: mainAlignmentSide,
    cross: getOppositePlacement(mainAlignmentSide)
  };
}

var hash = {
  start: 'end',
  end: 'start'
};

function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

var sides = ['top', 'right', 'bottom', 'left'];
var allPlacements = /*#__PURE__*/sides.reduce(function (acc, side) {
  return acc.concat(side, side + "-start", side + "-end");
}, []);

function getPlacementList(alignment, autoAlignment, allowedPlacements) {
  var allowedPlacementsSortedByAlignment = alignment ? [].concat(_toConsumableArray(allowedPlacements.filter(function (placement) {
    return getAlignment(placement) === alignment;
  })), _toConsumableArray(allowedPlacements.filter(function (placement) {
    return getAlignment(placement) !== alignment;
  }))) : allowedPlacements.filter(function (placement) {
    return getSide(placement) === placement;
  });
  return allowedPlacementsSortedByAlignment.filter(function (placement) {
    if (alignment) {
      return getAlignment(placement) === alignment || (autoAlignment ? getOppositeAlignmentPlacement(placement) !== placement : false);
    }

    return true;
  });
}
/**
 * Automatically chooses the `placement` which has the most space available.
 * @see https://floating-ui.com/docs/autoPlacement
 */


var autoPlacement = function autoPlacement(options) {
  if (options === void 0) {
    options = {};
  }

  return {
    name: 'autoPlacement',
    options: options,
    fn: function () {
      var _fn2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(middlewareArguments) {
        var _middlewareData$autoP, _middlewareData$autoP2, _middlewareData$autoP3, _middlewareData$autoP4, _placementsSortedByLe, x, y, rects, middlewareData, placement, platform, elements, _options, _options$alignment, alignment, _options$allowedPlace, allowedPlacements, _options$autoAlignmen, autoAlignment, detectOverflowOptions, placements, overflow, currentIndex, currentPlacement, _getAlignmentSides, main, cross, currentOverflows, allOverflows, nextPlacement, placementsSortedByLeastOverflow, placementThatFitsOnAllSides, resetPlacement;

        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                x = middlewareArguments.x, y = middlewareArguments.y, rects = middlewareArguments.rects, middlewareData = middlewareArguments.middlewareData, placement = middlewareArguments.placement, platform = middlewareArguments.platform, elements = middlewareArguments.elements;
                _options = options, _options$alignment = _options.alignment, alignment = _options$alignment === void 0 ? null : _options$alignment, _options$allowedPlace = _options.allowedPlacements, allowedPlacements = _options$allowedPlace === void 0 ? allPlacements : _options$allowedPlace, _options$autoAlignmen = _options.autoAlignment, autoAlignment = _options$autoAlignmen === void 0 ? true : _options$autoAlignmen, detectOverflowOptions = _objectWithoutProperties(_options, ["alignment", "allowedPlacements", "autoAlignment"]);
                placements = getPlacementList(alignment, autoAlignment, allowedPlacements);
                _context3.next = 5;
                return detectOverflow(middlewareArguments, detectOverflowOptions);

              case 5:
                overflow = _context3.sent;
                currentIndex = (_middlewareData$autoP = (_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.index) != null ? _middlewareData$autoP : 0;
                currentPlacement = placements[currentIndex];

                if (!(currentPlacement == null)) {
                  _context3.next = 10;
                  break;
                }

                return _context3.abrupt("return", {});

              case 10:
                _context3.t0 = getAlignmentSides;
                _context3.t1 = currentPlacement;
                _context3.t2 = rects;
                _context3.next = 15;
                return platform.isRTL == null ? void 0 : platform.isRTL(elements.floating);

              case 15:
                _context3.t3 = _context3.sent;
                _getAlignmentSides = (0, _context3.t0)(_context3.t1, _context3.t2, _context3.t3);
                main = _getAlignmentSides.main;
                cross = _getAlignmentSides.cross;

                if (!(placement !== currentPlacement)) {
                  _context3.next = 21;
                  break;
                }

                return _context3.abrupt("return", {
                  x: x,
                  y: y,
                  reset: {
                    placement: placements[0]
                  }
                });

              case 21:
                currentOverflows = [overflow[getSide(currentPlacement)], overflow[main], overflow[cross]];
                allOverflows = [].concat(_toConsumableArray((_middlewareData$autoP3 = (_middlewareData$autoP4 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP4.overflows) != null ? _middlewareData$autoP3 : []), [{
                  placement: currentPlacement,
                  overflows: currentOverflows
                }]);
                nextPlacement = placements[currentIndex + 1]; // There are more placements to check

                if (!nextPlacement) {
                  _context3.next = 26;
                  break;
                }

                return _context3.abrupt("return", {
                  data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                  },
                  reset: {
                    placement: nextPlacement
                  }
                });

              case 26:
                placementsSortedByLeastOverflow = allOverflows.slice().sort(function (a, b) {
                  return a.overflows[0] - b.overflows[0];
                });
                placementThatFitsOnAllSides = (_placementsSortedByLe = placementsSortedByLeastOverflow.find(function (_ref) {
                  var overflows = _ref.overflows;
                  return overflows.every(function (overflow) {
                    return overflow <= 0;
                  });
                })) == null ? void 0 : _placementsSortedByLe.placement;
                resetPlacement = placementThatFitsOnAllSides != null ? placementThatFitsOnAllSides : placementsSortedByLeastOverflow[0].placement;

                if (!(resetPlacement !== placement)) {
                  _context3.next = 31;
                  break;
                }

                return _context3.abrupt("return", {
                  data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                  },
                  reset: {
                    placement: resetPlacement
                  }
                });

              case 31:
                return _context3.abrupt("return", {});

              case 32:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function fn(_x7) {
        return _fn2.apply(this, arguments);
      }

      return fn;
    }()
  };
};

function getExpandedPlacements(placement) {
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
/**
 * Changes the placement of the floating element to one that will fit if the
 * initially specified `placement` does not.
 * @see https://floating-ui.com/docs/flip
 */


var flip = function flip(options) {
  if (options === void 0) {
    options = {};
  }

  return {
    name: 'flip',
    options: options,
    fn: function () {
      var _fn3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(middlewareArguments) {
        var _middlewareData$flip, placement, middlewareData, rects, initialPlacement, platform, elements, _options2, _options2$mainAxis, checkMainAxis, _options2$crossAxis, checkCrossAxis, specifiedFallbackPlacements, _options2$fallbackStr, fallbackStrategy, _options2$flipAlignme, flipAlignment, detectOverflowOptions, side, isBasePlacement, fallbackPlacements, placements, overflow, overflows, overflowsData, _getAlignmentSides2, main, cross, _middlewareData$flip$, _middlewareData$flip2, nextIndex, nextPlacement, resetPlacement, _overflowsData$map$so, _placement;

        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                placement = middlewareArguments.placement, middlewareData = middlewareArguments.middlewareData, rects = middlewareArguments.rects, initialPlacement = middlewareArguments.initialPlacement, platform = middlewareArguments.platform, elements = middlewareArguments.elements;
                _options2 = options, _options2$mainAxis = _options2.mainAxis, checkMainAxis = _options2$mainAxis === void 0 ? true : _options2$mainAxis, _options2$crossAxis = _options2.crossAxis, checkCrossAxis = _options2$crossAxis === void 0 ? true : _options2$crossAxis, specifiedFallbackPlacements = _options2.fallbackPlacements, _options2$fallbackStr = _options2.fallbackStrategy, fallbackStrategy = _options2$fallbackStr === void 0 ? 'bestFit' : _options2$fallbackStr, _options2$flipAlignme = _options2.flipAlignment, flipAlignment = _options2$flipAlignme === void 0 ? true : _options2$flipAlignme, detectOverflowOptions = _objectWithoutProperties(_options2, ["mainAxis", "crossAxis", "fallbackPlacements", "fallbackStrategy", "flipAlignment"]);
                side = getSide(placement);
                isBasePlacement = side === initialPlacement;
                fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
                placements = [initialPlacement].concat(_toConsumableArray(fallbackPlacements));
                _context4.next = 8;
                return detectOverflow(middlewareArguments, detectOverflowOptions);

              case 8:
                overflow = _context4.sent;
                overflows = [];
                overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];

                if (checkMainAxis) {
                  overflows.push(overflow[side]);
                }

                if (!checkCrossAxis) {
                  _context4.next = 23;
                  break;
                }

                _context4.t0 = getAlignmentSides;
                _context4.t1 = placement;
                _context4.t2 = rects;
                _context4.next = 18;
                return platform.isRTL == null ? void 0 : platform.isRTL(elements.floating);

              case 18:
                _context4.t3 = _context4.sent;
                _getAlignmentSides2 = (0, _context4.t0)(_context4.t1, _context4.t2, _context4.t3);
                main = _getAlignmentSides2.main;
                cross = _getAlignmentSides2.cross;
                overflows.push(overflow[main], overflow[cross]);

              case 23:
                overflowsData = [].concat(_toConsumableArray(overflowsData), [{
                  placement: placement,
                  overflows: overflows
                }]); // One or more sides is overflowing

                if (overflows.every(function (side) {
                  return side <= 0;
                })) {
                  _context4.next = 40;
                  break;
                }

                nextIndex = ((_middlewareData$flip$ = (_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) != null ? _middlewareData$flip$ : 0) + 1;
                nextPlacement = placements[nextIndex];

                if (!nextPlacement) {
                  _context4.next = 29;
                  break;
                }

                return _context4.abrupt("return", {
                  data: {
                    index: nextIndex,
                    overflows: overflowsData
                  },
                  reset: {
                    placement: nextPlacement
                  }
                });

              case 29:
                resetPlacement = 'bottom';
                _context4.t4 = fallbackStrategy;
                _context4.next = _context4.t4 === 'bestFit' ? 33 : _context4.t4 === 'initialPlacement' ? 36 : 38;
                break;

              case 33:
                _placement = (_overflowsData$map$so = overflowsData.map(function (d) {
                  return [d, d.overflows.filter(function (overflow) {
                    return overflow > 0;
                  }).reduce(function (acc, overflow) {
                    return acc + overflow;
                  }, 0)];
                }).sort(function (a, b) {
                  return a[1] - b[1];
                })[0]) == null ? void 0 : _overflowsData$map$so[0].placement;

                if (_placement) {
                  resetPlacement = _placement;
                }

                return _context4.abrupt("break", 38);

              case 36:
                resetPlacement = initialPlacement;
                return _context4.abrupt("break", 38);

              case 38:
                if (!(placement !== resetPlacement)) {
                  _context4.next = 40;
                  break;
                }

                return _context4.abrupt("return", {
                  reset: {
                    placement: resetPlacement
                  }
                });

              case 40:
                return _context4.abrupt("return", {});

              case 41:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function fn(_x8) {
        return _fn3.apply(this, arguments);
      }

      return fn;
    }()
  };
};

function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}

function isAnySideFullyClipped(overflow) {
  return sides.some(function (side) {
    return overflow[side] >= 0;
  });
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */


var hide = function hide(_temp) {
  var _ref5 = _temp === void 0 ? {} : _temp,
      _ref5$strategy = _ref5.strategy,
      strategy = _ref5$strategy === void 0 ? 'referenceHidden' : _ref5$strategy,
      detectOverflowOptions = _objectWithoutProperties(_ref5, ["strategy"]);

  return {
    name: 'hide',
    fn: function () {
      var _fn4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(middlewareArguments) {
        var rects, overflow, offsets, _overflow, _offsets;

        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                rects = middlewareArguments.rects;
                _context5.t0 = strategy;
                _context5.next = _context5.t0 === 'referenceHidden' ? 4 : _context5.t0 === 'escaped' ? 9 : 14;
                break;

              case 4:
                _context5.next = 6;
                return detectOverflow(middlewareArguments, _objectSpread({}, detectOverflowOptions, {
                  elementContext: 'reference'
                }));

              case 6:
                overflow = _context5.sent;
                offsets = getSideOffsets(overflow, rects.reference);
                return _context5.abrupt("return", {
                  data: {
                    referenceHiddenOffsets: offsets,
                    referenceHidden: isAnySideFullyClipped(offsets)
                  }
                });

              case 9:
                _context5.next = 11;
                return detectOverflow(middlewareArguments, _objectSpread({}, detectOverflowOptions, {
                  altBoundary: true
                }));

              case 11:
                _overflow = _context5.sent;
                _offsets = getSideOffsets(_overflow, rects.floating);
                return _context5.abrupt("return", {
                  data: {
                    escapedOffsets: _offsets,
                    escaped: isAnySideFullyClipped(_offsets)
                  }
                });

              case 14:
                return _context5.abrupt("return", {});

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function fn(_x9) {
        return _fn4.apply(this, arguments);
      }

      return fn;
    }()
  };
};

function convertValueToCoords(_x10, _x11) {
  return _convertValueToCoords.apply(this, arguments);
}
/**
 * Displaces the floating element from its reference element.
 * @see https://floating-ui.com/docs/offset
 */


function _convertValueToCoords() {
  _convertValueToCoords = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(middlewareArguments, value) {
    var placement, platform, elements, rtl, side, alignment, isVertical, mainAxisMulti, crossAxisMulti, rawValue, _ref7, mainAxis, crossAxis, alignmentAxis;

    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            placement = middlewareArguments.placement, platform = middlewareArguments.platform, elements = middlewareArguments.elements;
            _context11.next = 3;
            return platform.isRTL == null ? void 0 : platform.isRTL(elements.floating);

          case 3:
            rtl = _context11.sent;
            side = getSide(placement);
            alignment = getAlignment(placement);
            isVertical = getMainAxisFromPlacement(placement) === 'x';
            mainAxisMulti = ['left', 'top'].includes(side) ? -1 : 1;
            crossAxisMulti = rtl && isVertical ? -1 : 1;
            rawValue = typeof value === 'function' ? value(middlewareArguments) : value; // eslint-disable-next-line prefer-const

            _ref7 = typeof rawValue === 'number' ? {
              mainAxis: rawValue,
              crossAxis: 0,
              alignmentAxis: null
            } : _objectSpread({
              mainAxis: 0,
              crossAxis: 0,
              alignmentAxis: null
            }, rawValue), mainAxis = _ref7.mainAxis, crossAxis = _ref7.crossAxis, alignmentAxis = _ref7.alignmentAxis;

            if (alignment && typeof alignmentAxis === 'number') {
              crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
            }

            return _context11.abrupt("return", isVertical ? {
              x: crossAxis * crossAxisMulti,
              y: mainAxis * mainAxisMulti
            } : {
              x: mainAxis * mainAxisMulti,
              y: crossAxis * crossAxisMulti
            });

          case 13:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _convertValueToCoords.apply(this, arguments);
}

var offset = function offset(value) {
  if (value === void 0) {
    value = 0;
  }

  return {
    name: 'offset',
    options: value,
    fn: function () {
      var _fn5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(middlewareArguments) {
        var x, y, diffCoords;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                x = middlewareArguments.x, y = middlewareArguments.y;
                _context6.next = 3;
                return convertValueToCoords(middlewareArguments, value);

              case 3:
                diffCoords = _context6.sent;
                return _context6.abrupt("return", {
                  x: x + diffCoords.x,
                  y: y + diffCoords.y,
                  data: diffCoords
                });

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function fn(_x12) {
        return _fn5.apply(this, arguments);
      }

      return fn;
    }()
  };
};

function getCrossAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
/**
 * Shifts the floating element in order to keep it in view when it will overflow
 * a clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */


var shift = function shift(options) {
  if (options === void 0) {
    options = {};
  }

  return {
    name: 'shift',
    options: options,
    fn: function () {
      var _fn6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(middlewareArguments) {
        var _objectSpread3;

        var x, y, placement, _options3, _options3$mainAxis, checkMainAxis, _options3$crossAxis, checkCrossAxis, _options3$limiter, limiter, detectOverflowOptions, coords, overflow, mainAxis, crossAxis, mainAxisCoord, crossAxisCoord, minSide, maxSide, _min, _max, _minSide, _maxSide, _min2, _max2, limitedCoords;

        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                x = middlewareArguments.x, y = middlewareArguments.y, placement = middlewareArguments.placement;
                _options3 = options, _options3$mainAxis = _options3.mainAxis, checkMainAxis = _options3$mainAxis === void 0 ? true : _options3$mainAxis, _options3$crossAxis = _options3.crossAxis, checkCrossAxis = _options3$crossAxis === void 0 ? false : _options3$crossAxis, _options3$limiter = _options3.limiter, limiter = _options3$limiter === void 0 ? {
                  fn: function fn(_ref) {
                    var x = _ref.x,
                        y = _ref.y;
                    return {
                      x: x,
                      y: y
                    };
                  }
                } : _options3$limiter, detectOverflowOptions = _objectWithoutProperties(_options3, ["mainAxis", "crossAxis", "limiter"]);
                coords = {
                  x: x,
                  y: y
                };
                _context7.next = 5;
                return detectOverflow(middlewareArguments, detectOverflowOptions);

              case 5:
                overflow = _context7.sent;
                mainAxis = getMainAxisFromPlacement(getSide(placement));
                crossAxis = getCrossAxis(mainAxis);
                mainAxisCoord = coords[mainAxis];
                crossAxisCoord = coords[crossAxis];

                if (checkMainAxis) {
                  minSide = mainAxis === 'y' ? 'top' : 'left';
                  maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                  _min = mainAxisCoord + overflow[minSide];
                  _max = mainAxisCoord - overflow[maxSide];
                  mainAxisCoord = within(_min, mainAxisCoord, _max);
                }

                if (checkCrossAxis) {
                  _minSide = crossAxis === 'y' ? 'top' : 'left';
                  _maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                  _min2 = crossAxisCoord + overflow[_minSide];
                  _max2 = crossAxisCoord - overflow[_maxSide];
                  crossAxisCoord = within(_min2, crossAxisCoord, _max2);
                }

                limitedCoords = limiter.fn(_objectSpread({}, middlewareArguments, (_objectSpread3 = {}, _defineProperty(_objectSpread3, mainAxis, mainAxisCoord), _defineProperty(_objectSpread3, crossAxis, crossAxisCoord), _objectSpread3)));
                return _context7.abrupt("return", _objectSpread({}, limitedCoords, {
                  data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                  }
                }));

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function fn(_x13) {
        return _fn6.apply(this, arguments);
      }

      return fn;
    }()
  };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */


var limitShift = function limitShift(options) {
  if (options === void 0) {
    options = {};
  }

  return {
    options: options,
    fn: function fn(middlewareArguments) {
      var _ref6;

      var x = middlewareArguments.x,
          y = middlewareArguments.y,
          placement = middlewareArguments.placement,
          rects = middlewareArguments.rects,
          middlewareData = middlewareArguments.middlewareData;
      var _options4 = options,
          _options4$offset = _options4.offset,
          offset = _options4$offset === void 0 ? 0 : _options4$offset,
          _options4$mainAxis = _options4.mainAxis,
          checkMainAxis = _options4$mainAxis === void 0 ? true : _options4$mainAxis,
          _options4$crossAxis = _options4.crossAxis,
          checkCrossAxis = _options4$crossAxis === void 0 ? true : _options4$crossAxis;
      var coords = {
        x: x,
        y: y
      };
      var mainAxis = getMainAxisFromPlacement(placement);
      var crossAxis = getCrossAxis(mainAxis);
      var mainAxisCoord = coords[mainAxis];
      var crossAxisCoord = coords[crossAxis];
      var rawOffset = typeof offset === 'function' ? offset(middlewareArguments) : offset;
      var computedOffset = typeof rawOffset === 'number' ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : _objectSpread({
        mainAxis: 0,
        crossAxis: 0
      }, rawOffset);

      if (checkMainAxis) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        var limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        var limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;

        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }

      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2, _middlewareData$offse3, _middlewareData$offse4;

        var _len = mainAxis === 'y' ? 'width' : 'height';

        var isOriginSide = ['top', 'left'].includes(getSide(placement));

        var _limitMin = rects.reference[crossAxis] - rects.floating[_len] + (isOriginSide ? (_middlewareData$offse = (_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) != null ? _middlewareData$offse : 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);

        var _limitMax = rects.reference[crossAxis] + rects.reference[_len] + (isOriginSide ? 0 : (_middlewareData$offse3 = (_middlewareData$offse4 = middlewareData.offset) == null ? void 0 : _middlewareData$offse4[crossAxis]) != null ? _middlewareData$offse3 : 0) - (isOriginSide ? computedOffset.crossAxis : 0);

        if (crossAxisCoord < _limitMin) {
          crossAxisCoord = _limitMin;
        } else if (crossAxisCoord > _limitMax) {
          crossAxisCoord = _limitMax;
        }
      }

      return _ref6 = {}, _defineProperty(_ref6, mainAxis, mainAxisCoord), _defineProperty(_ref6, crossAxis, crossAxisCoord), _ref6;
    }
  };
};
/**
 * Provides data to change the size of the floating element. For instance,
 * prevent it from overflowing its clipping boundary or match the width of the
 * reference element.
 * @see https://floating-ui.com/docs/size
 */


var size = function size(options) {
  if (options === void 0) {
    options = {};
  }

  return {
    name: 'size',
    options: options,
    fn: function () {
      var _fn7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(middlewareArguments) {
        var placement, rects, platform, elements, _options5, _options5$apply, apply, detectOverflowOptions, overflow, side, alignment, heightSide, widthSide, xMin, xMax, yMin, yMax, dimensions, nextDimensions;

        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                placement = middlewareArguments.placement, rects = middlewareArguments.rects, platform = middlewareArguments.platform, elements = middlewareArguments.elements;
                _options5 = options, _options5$apply = _options5.apply, apply = _options5$apply === void 0 ? function () {} : _options5$apply, detectOverflowOptions = _objectWithoutProperties(_options5, ["apply"]);
                _context8.next = 4;
                return detectOverflow(middlewareArguments, detectOverflowOptions);

              case 4:
                overflow = _context8.sent;
                side = getSide(placement);
                alignment = getAlignment(placement);

                if (!(side === 'top' || side === 'bottom')) {
                  _context8.next = 26;
                  break;
                }

                heightSide = side;
                _context8.t0 = alignment;
                _context8.next = 12;
                return platform.isRTL == null ? void 0 : platform.isRTL(elements.floating);

              case 12:
                if (!_context8.sent) {
                  _context8.next = 16;
                  break;
                }

                _context8.t1 = 'start';
                _context8.next = 17;
                break;

              case 16:
                _context8.t1 = 'end';

              case 17:
                _context8.t2 = _context8.t1;

                if (!(_context8.t0 === _context8.t2)) {
                  _context8.next = 22;
                  break;
                }

                _context8.t3 = 'left';
                _context8.next = 23;
                break;

              case 22:
                _context8.t3 = 'right';

              case 23:
                widthSide = _context8.t3;
                _context8.next = 28;
                break;

              case 26:
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';

              case 28:
                xMin = max(overflow.left, 0);
                xMax = max(overflow.right, 0);
                yMin = max(overflow.top, 0);
                yMax = max(overflow.bottom, 0);
                dimensions = {
                  availableHeight: rects.floating.height - (['left', 'right'].includes(placement) ? 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom)) : overflow[heightSide]),
                  availableWidth: rects.floating.width - (['top', 'bottom'].includes(placement) ? 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right)) : overflow[widthSide])
                };
                _context8.next = 35;
                return apply(_objectSpread({}, middlewareArguments, dimensions));

              case 35:
                _context8.next = 37;
                return platform.getDimensions(elements.floating);

              case 37:
                nextDimensions = _context8.sent;

                if (!(rects.floating.width !== nextDimensions.width || rects.floating.height !== nextDimensions.height)) {
                  _context8.next = 40;
                  break;
                }

                return _context8.abrupt("return", {
                  reset: {
                    rects: true
                  }
                });

              case 40:
                return _context8.abrupt("return", {});

              case 41:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function fn(_x14) {
        return _fn7.apply(this, arguments);
      }

      return fn;
    }()
  };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */


var inline = function inline(options) {
  if (options === void 0) {
    options = {};
  }

  return {
    name: 'inline',
    options: options,
    fn: function () {
      var _fn8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(middlewareArguments) {
        var _await$platform$getCl, placement, elements, rects, platform, strategy, _options6, _options6$padding, padding, x, y, fallback, clientRects, paddingObject, getBoundingClientRect, resetRects;

        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                getBoundingClientRect = function _getBoundingClientRec() {
                  // There are two rects and they are disjoined
                  if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) {
                    var _clientRects$find; // Find the first rect in which the point is fully inside


                    return (_clientRects$find = clientRects.find(function (rect) {
                      return x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom;
                    })) != null ? _clientRects$find : fallback;
                  } // There are 2 or more connected rects


                  if (clientRects.length >= 2) {
                    if (getMainAxisFromPlacement(placement) === 'x') {
                      var firstRect = clientRects[0];
                      var lastRect = clientRects[clientRects.length - 1];
                      var isTop = getSide(placement) === 'top';
                      var _top = firstRect.top;
                      var _bottom = lastRect.bottom;

                      var _left = isTop ? firstRect.left : lastRect.left;

                      var _right = isTop ? firstRect.right : lastRect.right;

                      var _width = _right - _left;

                      var _height = _bottom - _top;

                      return {
                        top: _top,
                        bottom: _bottom,
                        left: _left,
                        right: _right,
                        width: _width,
                        height: _height,
                        x: _left,
                        y: _top
                      };
                    }

                    var isLeftSide = getSide(placement) === 'left';
                    var maxRight = max.apply(void 0, _toConsumableArray(clientRects.map(function (rect) {
                      return rect.right;
                    })));
                    var minLeft = min.apply(void 0, _toConsumableArray(clientRects.map(function (rect) {
                      return rect.left;
                    })));
                    var measureRects = clientRects.filter(function (rect) {
                      return isLeftSide ? rect.left === minLeft : rect.right === maxRight;
                    });
                    var top = measureRects[0].top;
                    var bottom = measureRects[measureRects.length - 1].bottom;
                    var left = minLeft;
                    var right = maxRight;
                    var width = right - left;
                    var height = bottom - top;
                    return {
                      top: top,
                      bottom: bottom,
                      left: left,
                      right: right,
                      width: width,
                      height: height,
                      x: left,
                      y: top
                    };
                  }

                  return fallback;
                };

                placement = middlewareArguments.placement, elements = middlewareArguments.elements, rects = middlewareArguments.rects, platform = middlewareArguments.platform, strategy = middlewareArguments.strategy; // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
                // ClientRect's bounds, despite the event listener being triggered. A
                // padding of 2 seems to handle this issue.

                _options6 = options, _options6$padding = _options6.padding, padding = _options6$padding === void 0 ? 2 : _options6$padding, x = _options6.x, y = _options6.y;
                _context9.t0 = rectToClientRect;

                if (!platform.convertOffsetParentRelativeRectToViewportRelativeRect) {
                  _context9.next = 17;
                  break;
                }

                _context9.t2 = platform;
                _context9.t3 = rects.reference;
                _context9.next = 9;
                return platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating);

              case 9:
                _context9.t4 = _context9.sent;
                _context9.t5 = strategy;
                _context9.t6 = {
                  rect: _context9.t3,
                  offsetParent: _context9.t4,
                  strategy: _context9.t5
                };
                _context9.next = 14;
                return _context9.t2.convertOffsetParentRelativeRectToViewportRelativeRect.call(_context9.t2, _context9.t6);

              case 14:
                _context9.t1 = _context9.sent;
                _context9.next = 18;
                break;

              case 17:
                _context9.t1 = rects.reference;

              case 18:
                _context9.t7 = _context9.t1;
                fallback = (0, _context9.t0)(_context9.t7);
                _context9.next = 22;
                return platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference);

              case 22:
                _context9.t8 = _await$platform$getCl = _context9.sent;

                if (!(_context9.t8 != null)) {
                  _context9.next = 27;
                  break;
                }

                _context9.t9 = _await$platform$getCl;
                _context9.next = 28;
                break;

              case 27:
                _context9.t9 = [];

              case 28:
                clientRects = _context9.t9;
                paddingObject = getSideObjectFromPadding(padding);
                _context9.next = 32;
                return platform.getElementRects({
                  reference: {
                    getBoundingClientRect: getBoundingClientRect
                  },
                  floating: elements.floating,
                  strategy: strategy
                });

              case 32:
                resetRects = _context9.sent;

                if (!(rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height)) {
                  _context9.next = 35;
                  break;
                }

                return _context9.abrupt("return", {
                  reset: {
                    rects: resetRects
                  }
                });

              case 35:
                return _context9.abrupt("return", {});

              case 36:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function fn(_x15) {
        return _fn8.apply(this, arguments);
      }

      return fn;
    }()
  };
};

export { arrow, autoPlacement, computePosition, detectOverflow, flip, hide, inline, limitShift, offset, rectToClientRect, shift, size };